import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import React from "react";
type Props = {
  caption: string;
};
export const Caption = React.forwardRef<HTMLDivElement, Props & React.ComponentPropsWithRef<"div">>((props, ref) => {
  const {
    caption
  } = props;
  return <_StyledDiv ref={ref}>
      <_StyledP>
        {caption}
      </_StyledP>
      <_StyledSpan />
    </_StyledDiv>;
});
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-sf-t5fjuu-0"
})({
  "display": "flex",
  "justifyContent": "space-between",
  "gap": "1.6rem",
  "paddingTop": "0.8rem",
  "@media (min-width: 1024px)": {
    "paddingTop": "1.6rem"
  }
});
var _StyledP = _styled2("p").withConfig({
  componentId: "sc-sf-t5fjuu-1"
})({
  "width": "min-content",
  "flex": "1 1 0%",
  "fontFamily": "Aeonik, ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif",
  "fontSize": "1.2rem",
  "lineHeight": "1.1",
  "letterSpacing": "0.024rem",
  "fontWeight": "400",
  "color": "var(--text-transparent)",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.1",
    "letterSpacing": "0.028000000000000004rem",
    "fontWeight": "400"
  }
});
var _StyledSpan = /*#__PURE__*/_styled3("span").withConfig({
  displayName: "caption___StyledSpan",
  componentId: "sc-1dqrwpd-0"
})({
  "height": "0.8rem",
  "width": "0.8rem",
  "flexShrink": "0",
  "--tw-translate-y": "50%",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(75 46 248 / var(--tw-bg-opacity))"
});